import {PieChart as RechartsPieChart, Pie, Cell, ResponsiveContainer} from 'recharts'
import {useTheme} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useMemo} from 'react'
import {PieChartLegend, PieChartLegendData} from '../pie-chart-legend/PieChartLegend'
import {useGetDashboardConsultants} from '../../query/useGetDashboardConsultants'
import {useTranslation} from '@/translations/i18n'

export const DashboardDoctorsPsychologistsPieChart = () => {
    const {palette} = useTheme()
    const {data} = useGetDashboardConsultants({
        fields: ['operativeConsultants']
    })
    const {t} = useTranslation()

    const chartData = useMemo(() => {
        return [
            {
                name: t('dashboard:doctors_psychologists_flat_rate'),
                value: data?.operativeConsultants?.doctors.flat_rate,
                color: palette.primary[400]
            },
            {
                name: t('dashboard:doctors_psychologists_consultant'),
                value: data?.operativeConsultants?.doctors.consultant,
                color: palette.primary[200]
            }
        ]
    }, [data])

    const legendData: PieChartLegendData[] = [
        {name: t('dashboard:doctors_psychologists_flat_rate'), color: palette.primary[400]},
        {name: t('dashboard:doctors_psychologists_consultant'), color: palette.primary[200]}
    ]

    return (
        <Flexbox align="center" gap={6}>
            <ResponsiveContainer width={120} height={120}>
                <RechartsPieChart>
                    <Pie data={chartData} cx="50%" cy="50%" outerRadius={60} dataKey="value">
                        {chartData.map((entry, index) => (
                            <Cell key={index} fill={entry.color} />
                        ))}
                    </Pie>
                </RechartsPieChart>
            </ResponsiveContainer>

            <PieChartLegend data={legendData} />
        </Flexbox>
    )
}
